import React, {FC} from "react"

import getCurrency from "@irati/deals/helpers/deals/currency"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import {Deal, DealType, PaymentCurrencyType, UserSaving} from "@irati/types"
import mainTheme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"
import isContentKey from "@irati/utils/lang/helpers/isContentKey"

import {usePointsBlendQuery} from "@irati/wallet/hooks/pointsBlend"
import {StyledLabel} from "../style"
import Price from "./Price"

type Props = {
  deal: Required<Deal>
  isBoosted: boolean
}

const DealPromoSavingInfo: FC<Props> = ({deal, isBoosted}) => {
  const {data: pointsBlend} = usePointsBlendQuery()
  const currency = getCurrency(deal) as PaymentCurrencyType
  const {type, savings} = deal
  const {userSavings, boostedSavings} = savings as Required<UserSaving>
  const isRewards = currency === PaymentCurrencyType.Rp
  const isFlexiPoint = currency === PaymentCurrencyType.Tt
  const isPointsBlend = (isRewards || isFlexiPoint) && pointsBlend?.walletBlend.visible
  const products = deal.productConfig?.products ?? []
  const flexiRewardPrice = products[0]?.salePrice?.value
  const price = isRewards ? flexiRewardPrice : userSavings.value!
  const prevPriceStyle = userSavings.type === DealSavingsTypes.PERCENTAGE ? "percent" : "currency"
  const isFlexiPointBoosted = isFlexiPoint && isBoosted
  const priceStyle = isRewards || isFlexiPointBoosted ? "number" : prevPriceStyle
  const prevPriceVal = boostedSavings?.oldSavings?.value!
  const priceCurrency = isFlexiPointBoosted ? null : currency

  let header = ""
  if (type === DealType.Company) {
    header = "perks.components.importantInfoBlock.importantInfoBlock.save"
  } else if (isRewards || isFlexiPoint) {
    header = products?.length > 1 ? "perks.deal.savings.label.spendFrom" : "perks.deal.savings.label.spend"
  }

  const label = isContentKey(header) ? <FormattedMessage id={header} /> : userSavings.header

  return (
    <>
      <StyledLabel>{label}</StyledLabel>
      {isBoosted && !isRewards && (
        <Price
          large
          currency={isPointsBlend ? pointsBlend.walletBlend.currency : currency}
          value={prevPriceVal!}
          style={prevPriceStyle}
          textDecoration="line-through"
          marginLeft={isBoosted && mainTheme.spacing.half}
        />
      )}
      <Price
        value={price!}
        currency={isPointsBlend ? pointsBlend.walletBlend.currency : priceCurrency}
        style={priceStyle}
        marginLeft={mainTheme.spacing.half}
        highlighted
      />
    </>
  )
}

export default DealPromoSavingInfo
